export default "__VITE_ASSET__Cgnc88zD__"